<template>
  <AiEducationLayout>
  <ContentWrap>
    <el-tabs v-model="activeTab" @tab-change="loadData">
      <el-tab-pane label="作业管理" name="assignment">
        <el-button
          v-hasPermi="['ai-education:assignment:write']"
          type="primary"
          @click="openAssignment"
          >新建作业</el-button
        >
        <el-table v-loading="loading" class="mt-12px" :data="assignments">
          <el-table-column prop="title" label="作业名称" min-width="180" />
          <el-table-column label="教学班" min-width="150"
            ><template #default="s">{{
              className(s.row.teachingClassId)
            }}</template></el-table-column
          >
          <el-table-column label="课程" min-width="170"
            ><template #default="s">{{
              courseName(s.row.trainCourseId)
            }}</template></el-table-column
          >
          <el-table-column label="截止时间" width="180">
            <template #default="s">{{ formatDateTime(s.row.dueTime) }}</template>
          </el-table-column>
          <el-table-column prop="maxAttempts" label="最大提交" width="100" />
          <el-table-column label="状态" width="90"
            ><template #default="s"
              ><el-tag :type="s.row.status === 10 ? 'success' : 'info'">{{
                s.row.status === 10 ? '已发布' : '草稿'
              }}</el-tag></template
            ></el-table-column
          >
          <el-table-column label="操作" width="230"
            ><template #default="s"
              ><el-button
                v-if="s.row.status === 0"
                v-hasPermi="['ai-education:assignment:write']"
                link
                type="primary"
                @click="openAssignment(s.row)"
                >编辑</el-button
              ><el-button
                v-if="s.row.status === 0"
                v-hasPermi="['ai-education:assignment:publish']"
                link
                type="primary"
                @click="publish(s.row.id)"
                >发布</el-button
              ><el-button link type="primary" @click="openSubmissions(s.row.id)"
                >提交与批改</el-button
              ></template
            ></el-table-column
          >
        </el-table>
      </el-tab-pane>

      <el-tab-pane label="课程知识库" name="knowledge">
        <el-button v-hasPermi="['ai-education:knowledge:write']" type="primary" @click="openBinding"
          >新增绑定</el-button
        >
        <el-table v-loading="loading" class="mt-12px" :data="bindings">
          <el-table-column label="学校" min-width="150"
            ><template #default="s">{{ schoolName(s.row.schoolId) }}</template></el-table-column
          >
          <el-table-column label="课程" min-width="170"
            ><template #default="s">{{
              courseName(s.row.trainCourseId)
            }}</template></el-table-column
          >
          <el-table-column label="知识库" min-width="170"
            ><template #default="s">{{
              knowledgeName(s.row.knowledgeId)
            }}</template></el-table-column
          >
          <el-table-column prop="similarityThreshold" label="相似度阈值" width="120" />
          <el-table-column prop="topK" label="召回数量" width="100" />
          <el-table-column label="状态" width="90"
            ><template #default="s"
              ><el-tag :type="s.row.enabled ? 'success' : 'info'">{{
                s.row.enabled ? '启用' : '停用'
              }}</el-tag></template
            ></el-table-column
          >
        </el-table>
      </el-tab-pane>

      <el-tab-pane label="转教师问题" name="feedback">
        <el-table v-loading="loading" :data="feedbackList">
          <el-table-column label="学生" min-width="150"
            ><template #default="s">{{ studentName(s.row.userId) }}</template></el-table-column
          >
          <el-table-column prop="comment" label="学生说明" min-width="260" />
          <el-table-column label="状态" width="100"
            ><template #default="s">{{
              s.row.status === 20 ? '已处理' : '待处理'
            }}</template></el-table-column
          >
          <el-table-column label="操作" width="100"
            ><template #default="s"
              ><el-button
                v-if="s.row.status !== 20"
                link
                type="primary"
                @click="resolveFeedback(s.row.id)"
                >办结</el-button
              ></template
            ></el-table-column
          >
        </el-table>
      </el-tab-pane>
    </el-tabs>
  </ContentWrap>

  <Dialog
    v-model="assignmentDialog"
    :title="assignmentForm.id ? '编辑作业' : '新建作业'"
    width="620px"
  >
    <el-form :model="assignmentForm" label-width="100px">
      <el-form-item label="作业名称" required
        ><el-input v-model="assignmentForm.title"
      /></el-form-item>
      <el-form-item label="教学班" required
        ><el-select
          v-model="assignmentForm.teachingClassId"
          class="w-100%"
          filterable
          placeholder="请选择教学班"
          @change="onTeachingClassChange"
          ><el-option
            v-for="item in teachingClasses"
            :key="item.id"
            :label="item.name"
            :value="item.id" /></el-select
      ></el-form-item>
      <el-form-item label="课程" required
        ><el-select
          v-model="assignmentForm.trainCourseId"
          class="w-100%"
          filterable
          placeholder="请选择课程"
          @change="onAssignmentCourseChange"
          ><el-option
            v-for="item in courses"
            :key="item.id"
            :label="item.title || item.name"
            :value="item.id" /></el-select
      ></el-form-item>
      <el-form-item label="章节"
        ><el-select
          v-model="assignmentForm.chapterId"
          class="w-100%"
          clearable
          filterable
          :disabled="!assignmentForm.trainCourseId"
          placeholder="可选，请先选择课程"
          ><el-option
            v-for="item in chapters"
            :key="item.id"
            :label="item.name || item.title"
            :value="item.id" /></el-select
      ></el-form-item>
      <el-form-item label="截止时间" required
        ><el-date-picker
          v-model="assignmentForm.dueTime"
          class="w-100%"
          type="datetime"
          value-format="YYYY-MM-DDTHH:mm:ss"
      /></el-form-item>
      <el-form-item label="允许重交"
        ><el-switch v-model="assignmentForm.allowResubmit"
      /></el-form-item>
      <el-form-item label="最大提交"
        ><el-input-number v-model="assignmentForm.maxAttempts" :min="1" :max="20"
      /></el-form-item>
      <el-form-item label="说明"
        ><el-input v-model="assignmentForm.description" type="textarea"
      /></el-form-item>
    </el-form>
    <template #footer
      ><el-button @click="assignmentDialog = false">取消</el-button
      ><el-button :loading="assignmentSaving" type="primary" @click="submitAssignment"
        >保存</el-button
      ></template
    >
  </Dialog>

  <Dialog v-model="bindingDialog" title="绑定课程知识库" width="540px">
    <el-form :model="bindingForm" label-width="100px">
      <el-form-item label="学校" required
        ><el-select
          v-model="bindingForm.schoolId"
          class="w-100%"
          filterable
          placeholder="请选择学校"
          ><el-option
            v-for="item in schools"
            :key="item.id"
            :label="item.name"
            :value="item.id" /></el-select
      ></el-form-item>
      <el-form-item label="课程" required
        ><el-select
          v-model="bindingForm.trainCourseId"
          class="w-100%"
          filterable
          placeholder="请选择课程"
          ><el-option
            v-for="item in courses"
            :key="item.id"
            :label="item.title || item.name"
            :value="item.id" /></el-select
      ></el-form-item>
      <el-form-item label="知识库" required
        ><el-select
          v-model="bindingForm.knowledgeId"
          class="w-100%"
          filterable
          placeholder="请选择知识库"
          ><el-option
            v-for="item in knowledgeBases"
            :key="item.id"
            :label="item.name"
            :value="item.id" /></el-select
      ></el-form-item>
      <el-form-item label="相似度阈值"
        ><el-input-number v-model="bindingForm.similarityThreshold" :min="0" :max="1" :step="0.05"
      /></el-form-item>
      <el-form-item label="召回数量"
        ><el-input-number v-model="bindingForm.topK" :min="1" :max="20"
      /></el-form-item>
    </el-form>
    <template #footer
      ><el-button @click="bindingDialog = false">取消</el-button
      ><el-button type="primary" @click="submitBinding">保存</el-button></template
    >
  </Dialog>

  <Dialog v-model="submissionDialog" title="作业提交与批改" width="900px">
    <el-table :data="submissions"
      ><el-table-column label="学生" min-width="150"
        ><template #default="s">{{ studentName(s.row.studentId) }}</template></el-table-column
      ><el-table-column prop="attemptNo" label="次数" width="70" /><el-table-column
        prop="content"
        label="提交内容"
        min-width="240"
      /><el-table-column prop="score" label="得分" width="80" /><el-table-column
        label="操作"
        width="100"
        ><template #default="s"
          ><el-button v-if="s.row.status === 10" link type="primary" @click="openReview(s.row)"
            >批改</el-button
          ></template
        ></el-table-column
      ></el-table
    >
  </Dialog>
  <Dialog v-model="reviewDialog" title="批改作业" width="480px"
    ><el-form :model="reviewForm" label-width="90px"
      ><el-form-item label="得分"
        ><el-input-number v-model="reviewForm.score" :min="0" :max="reviewMaxScore" /></el-form-item
      ><el-form-item label="评语"
        ><el-input v-model="reviewForm.feedback" type="textarea" /></el-form-item
      ><el-form-item label="退回重交"
        ><el-switch v-model="reviewForm.returnForResubmit" /></el-form-item></el-form
    ><template #footer
      ><el-button @click="reviewDialog = false">取消</el-button
      ><el-button type="primary" @click="submitReview">确认</el-button></template
    ></Dialog
  >
  </AiEducationLayout>
</template>

<script lang="ts">
export default {
  name: 'AiEducationLearning'
}
</script>

<script setup lang="ts">
import * as Api from '@/api/aiEducation'
import { formatDate } from '@/utils/formatTime'
import { useBusinessOptions } from './useBusinessOptions'
import AiEducationLayout from './layout/AiEducationLayout.vue'

/** 统一展示截止时间（兼容字符串 / 毫秒时间戳 / LocalDateTime 数组） */
function pad2(n: number) {
  return String(n).padStart(2, '0')
}
function formatDateTime(v: any) {
  if (v == null || v === '') return '—'
  let d: Date | null = null
  if (typeof v === 'number' || /^\d{10,13}$/.test(String(v).trim())) {
    const n = Number(v)
    const ms = String(v).trim().length <= 10 ? n * 1000 : n
    d = new Date(ms)
  } else if (Array.isArray(v) && v.length >= 3) {
    const [y, m, day, hh = 0, mm = 0, ss = 0] = v
    d = new Date(y, m - 1, day, hh, mm, ss)
  } else if (typeof v === 'string') {
    // 已是 yyyy-MM-dd HH:mm:ss
    if (/^\d{4}-\d{2}-\d{2}/.test(v)) return v.length >= 16 ? v.slice(0, 19) : v
    const parsed = new Date(v.replace(/-/g, '/'))
    if (!Number.isNaN(parsed.getTime())) d = parsed
  } else if (v instanceof Date) {
    d = v
  }
  if (!d || Number.isNaN(d.getTime())) return '—'
  return `${d.getFullYear()}-${pad2(d.getMonth() + 1)}-${pad2(d.getDate())} ${pad2(d.getHours())}:${pad2(d.getMinutes())}:${pad2(d.getSeconds())}`
}

const message = useMessage()
const activeTab = ref('assignment')
const loading = ref(false)
const assignments = ref<Api.AssignmentVO[]>([])
const bindings = ref<Api.KnowledgeBindingVO[]>([])
const feedbackList = ref<Api.AiFeedbackVO[]>([])
const submissions = ref<Api.AssignmentSubmissionVO[]>([])
const assignmentDialog = ref(false)
const bindingDialog = ref(false)
const submissionDialog = ref(false)
const reviewDialog = ref(false)
const assignmentSaving = ref(false)
const reviewMaxScore = ref(100)
const currentAssignmentId = ref(0)
const assignmentForm = reactive<Api.AssignmentVO>({
  teachingClassId: undefined as unknown as number,
  trainCourseId: undefined as unknown as number,
  title: '',
  dueTime: '',
  maxScore: 100,
  allowResubmit: false,
  maxAttempts: 1
})
const bindingForm = reactive<Api.KnowledgeBindingVO>({
  schoolId: undefined as unknown as number,
  trainCourseId: undefined as unknown as number,
  knowledgeId: undefined as unknown as number,
  similarityThreshold: 0.6,
  topK: 5,
  enabled: true
})
const reviewForm = reactive({ submissionId: 0, score: 0, feedback: '', returnForResubmit: false })
const {
  schools,
  teachingClasses,
  courses,
  chapters,
  knowledgeBases,
  loadBaseOptions,
  loadChapters,
  searchStudents,
  schoolName,
  className,
  courseName,
  knowledgeName,
  studentName
} = useBusinessOptions()

const loadData = async () => {
  loading.value = true
  try {
    if (activeTab.value === 'assignment') assignments.value = await Api.getAssignmentList()
    if (activeTab.value === 'knowledge') bindings.value = await Api.getKnowledgeBindingList()
    if (activeTab.value === 'feedback') {
      feedbackList.value = await Api.getEscalatedAiFeedbackList()
      await searchStudents()
    }
  } finally {
    loading.value = false
  }
}
const openAssignment = async (row?: Api.AssignmentVO) => {
  Object.assign(assignmentForm, {
    id: row?.id,
    teachingClassId: row?.teachingClassId,
    trainCourseId: row?.trainCourseId,
    chapterId: row?.chapterId,
    title: row?.title || '',
    description: row?.description || '',
    dueTime: row?.dueTime || '',
    maxScore: row?.maxScore ?? 100,
    allowResubmit: row?.allowResubmit ?? false,
    maxAttempts: row?.maxAttempts ?? 1
  })
  if (row?.trainCourseId) await loadChapters(row.trainCourseId)
  else chapters.value = []
  assignmentDialog.value = true
}
const openBinding = () => {
  Object.assign(bindingForm, {
    schoolId: undefined,
    trainCourseId: undefined,
    knowledgeId: undefined,
    similarityThreshold: 0.6,
    topK: 5,
    enabled: true
  })
  bindingDialog.value = true
}
const onAssignmentCourseChange = async (id?: number) => {
  assignmentForm.chapterId = undefined
  await loadChapters(id)
}
const onTeachingClassChange = async (id?: number) => {
  const teachingClass = teachingClasses.value.find((item) => item.id === id)
  assignmentForm.trainCourseId = teachingClass?.trainCourseId as number
  await onAssignmentCourseChange(assignmentForm.trainCourseId)
}
const submitAssignment = async () => {
  if (
    !assignmentForm.title ||
    !assignmentForm.teachingClassId ||
    !assignmentForm.trainCourseId ||
    !assignmentForm.dueTime
  )
    return message.warning('请完整选择教学班、课程并填写截止时间')
  assignmentSaving.value = true
  try {
    await Api.saveAssignment({ ...assignmentForm, title: assignmentForm.title.trim() })
    assignmentDialog.value = false
    message.success('保存成功')
    await loadData()
  } finally {
    assignmentSaving.value = false
  }
}
const publish = async (id?: number) => {
  if (!id) return
  await message.confirm('确认发布该作业？')
  await Api.publishAssignment(id)
  await loadData()
}
const submitBinding = async () => {
  if (!bindingForm.schoolId || !bindingForm.trainCourseId || !bindingForm.knowledgeId)
    return message.warning('请选择学校、课程和知识库')
  await Api.saveKnowledgeBinding(bindingForm)
  bindingDialog.value = false
  message.success('保存成功')
  await loadData()
}
const resolveFeedback = async (id: number) => {
  await Api.resolveAiFeedback(id)
  await loadData()
}
const openSubmissions = async (id?: number) => {
  if (!id) return
  currentAssignmentId.value = id
  submissions.value = await Api.getAssignmentSubmissionList(id)
  await searchStudents()
  submissionDialog.value = true
}
const openReview = (row: Api.AssignmentSubmissionVO) => {
  reviewMaxScore.value =
    assignments.value.find((item) => item.id === row.assignmentId)?.maxScore || 100
  Object.assign(reviewForm, {
    submissionId: row.id,
    score: row.score || 0,
    feedback: '',
    returnForResubmit: false
  })
  reviewDialog.value = true
}
const submitReview = async () => {
  await Api.reviewAssignmentSubmission(reviewForm)
  reviewDialog.value = false
  submissions.value = await Api.getAssignmentSubmissionList(currentAssignmentId.value)
  message.success('批改成功')
}
onMounted(async () => {
  await loadBaseOptions()
  await loadData()
})
</script>
